import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/sql_tabelas_monitoradas";

const TITULO = "Tabelas monitoradas (SQL) — Milky Moo Palmares";
const DESCRICAO =
  "Escolha quais tabelas do banco terão suas alterações registradas automaticamente no histórico de comandos SQL.";

export const Route = createFileRoute("/_authenticated/sql_tabelas_monitoradas")({
  head: () => ({
    meta: [
      { title: TITULO },
      { name: "description", content: DESCRICAO },
      { property: "og:title", content: TITULO },
      { property: "og:description", content: DESCRICAO },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
